angular.module('SpidApp')

.constant('AffranchissementAdapterConfig', {
  name : 'Affranchissement',
  fields : [
    {
    	local   : 'code_affranchissement',
    	distant : 'code_affranchissement'
    }, {
    	local   : 'lib_court',
    	distant : 'lib_court'
    }, {
    	local   : 'lib_long',
        distant : 'lib_long'
    }, {
        local   : 'commentaire',
    	distant : 'commentaire'
    }, {
    	local   : 'is_available',
    	distant : 'is_available'
    }, {
    	local   : 'type_reference',
    	distant : 'type_reference'
    }, {
    	local   : 'template_impression',
    	distant : 'template_impression'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }, {
    	local   : 'deleted_at',
    	distant : 'deleted_at'
    }
  ]
})
